import NotificationActions from 'actions/Notification'
import ActionStatus from 'components/ActionStatus'
import CountdownNotification from 'components/Countdown'
import { InputLabel } from 'components/InputLabel'
import { LabelsForInput } from 'components/LabelsForInputs'
import { SwitchToggle } from 'components/SwitchToggle'
import { TextArea } from 'components/TextArea'
import { notificationStatus } from 'constants/notificationStatus'
import { useEffect, useMemo, useState } from 'react'
import { FieldValues, UseFormRegister, useForm } from 'react-hook-form'
import { AiOutlineExclamationCircle } from 'react-icons/ai'
import { BsQuestionLg } from 'react-icons/bs'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import NotificationService from 'services/Notification'
import { NotificationType } from 'types/notification'
import {
    calculateTimeLeft,
    damage_level,
    getCorIncidente,
    getDamage,
    getWarningCountdownColor,
    isSimplifiedTreatment
} from 'utils/damage'
import { textAreaSmallStyles, textAreaStyles } from '../NotificationData/styles'
import { ButtonAction, MoreDetailsText, SwitchDiv, actionsBack, inputRequiredStyle } from './styles'
import { AuthenticationReducer, UserDataType } from 'types/autentication'
import { Alert } from 'components/Modals/Alert'
import { SubTitleText, TitleText } from 'pages/NotifyEvent/styles'
import { Tooltip } from 'react-tooltip'
import { RootReducerState } from 'types/global'

interface TreatmentStep5Props {
    tooltipAlert: string
    notification: NotificationType
    notificationStatusState: string
    statusIsPendingFinishOrFinished: boolean
    currentUser: UserDataType
    setDisclosure: Function
    setDisclosureFieldsAutoSave: Function
    disclosureError: string
    managersReviewError: string
    showDisclosure: boolean
}
const FinishStep = ({
    tooltipAlert,
    statusIsPendingFinishOrFinished: statusIsArchivedOrFinished,
    notification,
    notificationStatusState,
    currentUser,
    setDisclosure,
    setDisclosureFieldsAutoSave,
    disclosureError,
    managersReviewError,
    showDisclosure
}: TreatmentStep5Props) => {

    const { id } = useParams()

    const notificationDispatch = useDispatch()
    const authenticationSelector: AuthenticationReducer = useSelector(
        (state: RootReducerState) => state.authenticationReducers
    )
    const isDone = useMemo(() => {
        return notificationStatusState === notificationStatus[4].label
    }, [notificationStatusState])

    const isExternalNotification = useMemo(() => {
        return (
            notification?.u_incident_classification?.value ===
            'u_incident_classification_external'
        )
    }, [notification])

    const isSimpleTreatment = useMemo(() => {
        const userProfile = authenticationSelector?.dataJwt?.profile
        const isImageRisk =
            notification?.u_image_risk?.value === 'u_image_risk_yes'
        const isSimplified = isSimplifiedTreatment(
            notification?.damage_level?.value,
            isImageRisk,
            userProfile
        )
        const isSemDano = notification?.damage_level?.display_value === 'Sem dano'
        return isSimplified || isSemDano
    }, [notification, authenticationSelector?.dataJwt?.profile])

    const {
        register,
        getValues,
        setValue,
        control,
        watch,
        formState: { errors }
    } = useForm()
    const [enabledDisclosureComments, setEnabledDisclosureComments] = useState(false)
    const uDisclosureComments = watch('u_disclosure_comments') || ''
    const uDisclosure = watch('u_disclosure')
    /**
     * Atualizando o status do Disclosure para o objeto de tratamento
     */
    useEffect(() => {
        setDisclosure({ u_disclosure_comments: uDisclosureComments, u_disclosure: uDisclosure ? `u_disclosure_yes` : `u_disclosure_no` })
    }, [uDisclosureComments, uDisclosure])

    useEffect(() => {
        setValue(
            'u_note_external_notification',
            notification?.u_note_external_notification?.display_value
        )
        setValue(
            'u_certifier_accreditor_protocol',
            notification?.u_certifier_accreditor_protocol?.display_value
        )

        setValue(
            'u_disclosure_comments',
            notification?.u_disclosure_comments?.value
        )

        let isDisclosure = ["u_disclosure_yes"].includes(notification?.u_disclosure?.value) || notification?.u_disclosure_comments?.value != ''
        if (isDisclosure) {
            setValue('u_disclosure', isDisclosure)
            setEnabledDisclosureComments(isDisclosure)
        }

    }, [notification])

    const submit = () => {
        const { u_certifier_accreditor_protocol, u_note_external_notification, u_managers_review } = getValues()       
        notification.u_certifier_accreditor_protocol = {
            display_value: u_certifier_accreditor_protocol,
            value: u_certifier_accreditor_protocol
        }
        notification.u_note_external_notification = {
            display_value: u_note_external_notification,
            value: u_note_external_notification
        }
        notification.u_managers_review = {
            display_value: u_managers_review,
            value: u_managers_review
        }

        let updateNotification = { u_certifier_accreditor_protocol, u_note_external_notification, u_managers_review }
        NotificationService.updateNotificationGeneric(
            {...updateNotification},
            notification?.sys_id?.value
        ).then((response: any) => {
            NotificationActions.setCurrentNotificationById(
                notificationDispatch,
                notification
            )
        })
    }

    const submitManagerReview = () => {
        const data = getValues()
        let currentNotification = { ...notification }
        const updateNotification = { u_managers_review: data.u_managers_review }
        currentNotification.u_managers_review = { display_value: data.u_managers_review, value: data.u_managers_review }
        NotificationService.updateNotificationGeneric(
            updateNotification,
            notification.sys_id?.value
        ).then((response: any) => {
            NotificationActions.setCurrentNotificationById(
                notificationDispatch,
                currentNotification
            )
        })

    }
    /**
     * Evento usado pelo SwitchToggle para atualizar o valor do campo u_disclosure
     * @param b 
     */
    const setDisclosureEnabled = (b: boolean) => {
        setEnabledDisclosureComments(b)
        setValue('u_disclosure', b)
        setValue('u_disclosure_comments', '')
        if (b) {
            let currentNotification = { ...notification }
            currentNotification.u_disclosure_comments = { display_value: '', value: '' }
            NotificationActions.setCurrentNotificationById(
                notificationDispatch,
                currentNotification
            )
        }

    }
    /**
     * Definindo condições para mostrar o campo de Disclosure
     */
    useEffect(() => {
        let showDisclosure: boolean;
        let damagesLevelClosureIds = damage_level.filter((damage) => ['leve', 'moderado', 'grave', 'obito'].includes(damage.value)).map((damage) => damage.id)

        if (!!(notification?.damage_level && notification?.u_image_risk)) {
            showDisclosure = damagesLevelClosureIds.includes(notification?.damage_level?.value) || notification?.u_image_risk.value !== 'u_image_risk_no' || notification?.u_never_events_or_sentinel_event?.value === 'yes'
        }
        
        if (!['5', '6'].includes(notification?.u_state?.value)) {
            setEnabledDisclosureComments(showDisclosure)
            setValue('u_disclosure', showDisclosure)
        }

    }, [])


    return (
        <div data-testid="test-finish-step" className="min-h-[400px]">
            {tooltipAlert && (
                <div className="px-6 mb-4" data-testid="test-finish-tooltip">
                    <ActionStatus text={tooltipAlert} status={1} />
                </div>
            )}
            {/* <Alert
                isOpen={showDisclosureInfo as boolean}
                handleCloseModal={() => setShowDisclosureInfo(false)}
                labelButtomClose={`Fechar`}
            >

                <div className='justify-center flex'>
                    <SubTitleText >
                        <b>Disclosure</b>
                        <p>Refere-se à divulgação, descoberta ou manifestação de algo indesejável, servindo como base para os profissionais da saúde, sejam eles assistências ou exercendo funções à nível de gerência, como um norte na forma de compartilhamento das informações aos pacientes e seus familiares na ocorrência de um evento adverso. Maiores detalhes disponíveis na Poldor 007.</p>
                    </SubTitleText>
                </div>
            </Alert> */}
            <div className="px-8 flex flex-row gap-12 mt-4 ">
                <div className="flex flex-col ">
                    <span className="text-xs">Chave da notificação</span>
                    <span className="text-sm font-bold">
                        {notification?.number?.display_value?.toUpperCase()}
                    </span>
                    <div>
                        <span
                            className={`chip-incidente mt-4 incidente-${getCorIncidente(
                                getDamage(notification?.damage_level?.value)
                                    ?.value
                            )}`}
                        >
                            {`${getDamage(notification?.damage_level?.value)
                                ?.label
                                }`}
                        </span>
                    </div>
                </div>
                <div className="flex flex-col">
                    <span className="text-xs">Data da ocorrência</span>
                    <span className="font-semibold text-sm">
                        {notification?.date_incident?.display_value}
                    </span>
                    <div className="flex flex-col mt-4">
                        <span className="text-xs">Título do incidente</span>
                        <span className="font-semibold text-sm">
                            {notification?.incident_title?.display_value}
                        </span>
                    </div>
                </div>
                <div className="flex flex-col">
                    <span className="text-xs">Unidade</span>
                    <span className="font-semibold text-sm">
                        {notification?.location_incident?.display_value}
                    </span>
                </div>
                <div className="flex flex-col">
                    <span className="text-xs">Setor</span>
                    <span className="font-semibold text-sm">
                        {notification?.incident_sector?.display_value}
                    </span>
                    {/* <CountdownNotification
                        notification={notification}
                        containerStyle="flex flex-row mt-8"
                        status={notification?.u_state?.value}
                        color={`${getWarningCountdownColor(notification)}`}
                        timer={`${calculateTimeLeft(notification)}`}
                    /> */}
                </div>
            </div>
            <div className="h-px w-full my-2 bg-gray-200 mx-8 mt-4" />

            {showDisclosure && (<div className="px-8">
                <div>
                    <MoreDetailsText
                        data-tooltip-id="my-tooltip-inline"
                        className={'mt-3'}
                    >
                        Foi feito o Disclosure?
                        <BsQuestionLg className="text-white bg-yellow rounded-full p-[2px] w-3.5 h-3.5" />
                    </MoreDetailsText>


                    <Tooltip id="my-tooltip-inline" style={{ backgroundColor: "#FFFFFF", color: "#222", fontWeight: '11px', zIndex: 1000000, width: '400px' }} place={'right'} opacity={1} border="1px solid #EEEEEE">
                        <b>Disclosure</b>
                        <p>Refere-se à divulgação, descoberta ou manifestação de algo indesejável, servindo como base para os profissionais da saúde, sejam eles assistências ou exercendo funções à nível de gerência, como um norte na forma de compartilhamento das informações aos pacientes e seus familiares na ocorrência de um evento adverso. Maiores detalhes disponíveis na Poldor 007.</p>
                    </Tooltip>

                </div>
                {/** lg:flex flex-row gap-4 justify-items-end */}
                <div className="w-full mt-3">
                    <div className="z-20">
                        <SwitchDiv>
                            <span
                                className={
                                    enabledDisclosureComments
                                        ? 'text-darkGray/80'
                                        : 'text-darkGray font-semibold'
                                }
                            >
                                Não
                            </span>
                            <SwitchToggle
                                disabled={
                                    !['location_manager', 'corporate_quality_management', 'location_qa', 'admin'].includes(currentUser?.profile)
                                    ||
                                    ['5', '6'].includes(notification?.u_state?.value)}
                                name="u_disclosure"
                                control={control}
                                enabled={enabledDisclosureComments}
                                style={{ opacity: ['5', '6'].includes(notification?.u_state?.value) ? 0.3 : 1 }}
                                setEnabled={setDisclosureEnabled}
                            />
                            <span
                                className={
                                    !enabledDisclosureComments
                                        ? 'text-darkGray/80'
                                        : 'text-darkGray font-semibold'
                                }
                            >
                                Sim
                            </span>
                        </SwitchDiv>

                        {(enabledDisclosureComments &&
                            (!['5', '6'].includes(notification?.u_state?.value) ?
                                (<TextArea
                                    container="mt-[28px] min-w-full max-w-full w-full"
                                    label="Descrição do Disclosure"
                                    subLabel="Por favor, descreva o que foi feito, com o maior número de detalhes possíveis."
                                    name="u_disclosure_comments"
                                    register={register}
                                    className={`max-h-[257px] h-[257px] ${disclosureError != '' &&
                                        inputRequiredStyle
                                        }`}
                                    placeholder="Digite aqui"
                                    inputLength={2000 - uDisclosureComments.length}
                                    maxLength={2000}
                                    onBlur={() => { setDisclosureFieldsAutoSave({ u_disclosure_comments: uDisclosureComments }) }}
                                    disabled={
                                        (['location_manager',].includes(currentUser?.profile) && ['4'].includes(notification?.u_state?.value))
                                        || ['nsp', 'unit_general_manager', 'corporate_quality_management'].includes(currentUser?.profile)
                                        || ['5', '6'].includes(notification?.u_state?.value)}
                                    rows={10}
                                    error={{
                                        message: disclosureError
                                    }}
                                />)
                                :
                                (<>
                                    <div className="flex flex-col mt-[28px] mb-[2px] min-w-full max-w-full w-full">
                                        <span className="text-sm font-semibold text-darkGray">Disclosure</span>
                                        <span className="text-xs font-normal outline-gray-200 rounded-lg py-3 text-darkGray ring-0 min-h-[257px]">{notification?.u_disclosure_comments?.display_value}</span>
                                    </div>
                                </>))
                        )}
                    </div>
                </div>
            </div>)}

            <div>
                {isDone ? (
                    <div className="px-8 flex flex-row gap-12 mt-4">
                        <div className="flex flex-col">
                            <span className="text-xs">Finalizada por</span>
                            <span className="text-sm font-bold">
                                {notification?.u_assigned_to?.display_value}
                            </span>
                        </div>
                        {/* <div className="flex gap-1">
                            <CountdownNotification
                                notification={notification}
                                status={notification?.u_state?.value}
                                color={`${getWarningCountdownColor(
                                    notification
                                )}`}
                                timer={`${calculateTimeLeft(notification)}`}
                            />
                        </div> */}
                    </div>
                ) : null}
            </div>
            <NotificationExternalData
                disabled={currentUser?.profile === 'corporate_quality_management'}
                statusIsArchivedOrFinished={statusIsArchivedOrFinished}
                notification={notification}
                isDone={isDone}
                register={register}
                submit={submit}
                isExternal={isExternalNotification}
            />

            {/* <FinishComment
                isDone={isDone} 
                register={register}
            /> */}
            <JustifySimpleTreatment
                managerReview={notification?.u_managers_review
                    ?.display_value}
                isDone={isDone}
                isSimpleTreatment={isSimpleTreatment && !showDisclosure}
                register={register}
                submitManagerReview={submitManagerReview}
                managersReviewError={managersReviewError}
            />

        </div>
    )
}

export { FinishStep }

export interface NotificationExternalDataProps {
    notification: NotificationType
    isExternal: boolean
    isDone: boolean
    statusIsArchivedOrFinished: boolean
    submit: () => void
    register: UseFormRegister<FieldValues>
    disabled: boolean
}
export const NotificationExternalData = ({
    statusIsArchivedOrFinished,
    isExternal,
    submit,
    register,
    isDone,
    notification,
    disabled
}: NotificationExternalDataProps) => {
    if (!isExternal) {
        return
    }
    return (
        <div className="px-8 mt-8" data-testid="test-notification-is-external">
            <div className="flex items-center gap-1">
                <AiOutlineExclamationCircle
                    className={'text-yellow font-bold'}
                    size={20}
                />
                <span className="text-blueTheme font-bold text-sm">
                    Essa é uma notificação externa
                </span>
            </div>
            {isDone ? (
                <div
                    className=" mt-2 ml-1 flex gap-16 w-full"
                    data-testid="test-external-notification-info"
                >
                    <div className="grid">
                        <span className="text-xstext-darkGray">
                            Número de Protocolo Anvisa, Certificadora e/ou
                            Instituição Acreditadora.
                        </span>
                        <span className="text-sm font-semibold text-darkGray">
                            {
                                notification?.u_certifier_accreditor_protocol
                                    ?.display_value
                            }
                        </span>
                    </div>
                    <div className="grid">
                        <span className="text-xstext-darkGray">
                            Observações sobre a notificação externa
                        </span>
                        <span className="text-sm font-semibold text-darkGray">
                            {
                                notification?.u_note_external_notification
                                    ?.display_value
                            }
                        </span>
                    </div>
                </div>
            ) : (
                <div
                    className="mt-2 flex gap-4 w-full"
                    data-testid="test-external-notification-input"
                >
                    <InputLabel
                        disabled={statusIsArchivedOrFinished && disabled}
                        container="w-full"
                        label="Número de Protocolo Anvisa, Certificadora e/ou Instituição Acreditadora."
                        name="u_certifier_accreditor_protocol"
                        register={register}
                        maxLength={50}
                        onBlur={() => {
                            submit()
                        }}
                        onKeyDown={(e) => {
                            const keyPressed = e.key
                            if (keyPressed === 'Enter') {
                                submit()
                            }
                        }}
                    />
                    <InputLabel
                        disabled={statusIsArchivedOrFinished && disabled}
                        onBlur={() => {
                            submit()
                        }}
                        onKeyDown={(e) => {
                            const keyPressed = e.key
                            if (keyPressed === 'Enter') {
                                submit()
                            }
                        }}
                        container="w-full"
                        label="Observações sobre a notificação externa"
                        name="u_note_external_notification"
                        register={register}
                        maxLength={50}
                    />
                </div>
            )}
        </div>
    )
}



export interface IJustifySimpleTreatmentProps {
    isDone: boolean
    managerReview?: string
    isSimpleTreatment: boolean
    register: UseFormRegister<FieldValues>
    submitManagerReview: () => void
    managersReviewError?: string
}
export const JustifySimpleTreatment =
    ({
        managerReview,
        isDone,
        isSimpleTreatment,
        register,
        submitManagerReview,
        managersReviewError
    }
        : IJustifySimpleTreatmentProps
    ) => {
        if (!isSimpleTreatment) {
            return null
        }
        if (!isDone) {
            return (<div
                data-testid="test-u_managers_review-container"
                className='px-8 mt-4'>
                <LabelsForInput
                    title="Justificativa da finalização"
                    subtitle="Obrigatório o parecer do responsável para finalizar a notificação."
                />
                <TextArea
                    defaultValue={managerReview}
                    name="u_managers_review"
                    register={register}
                    className={`${textAreaStyles} ${managersReviewError && inputRequiredStyle}`}
                    placeholder="Digite aqui"
                    rows={8}
                    onBlur={() => {
                        submitManagerReview()
                    }}
                    error={{
                        message: managersReviewError
                    }}
                />
            </div>)
        }
        return (
            <div data-testid="test-justify-simple-treatment" className="grid px-8 mt-6">
                <span className="text-xs text-darkGray">
                Justificativa da finalização
                </span>
                <span className="text-sm font-semibold text-darkGray">
                    {managerReview}
                </span>
            </div>
        )
    }


    // const FinishComment = ({
    //     register,
    //     isDone
    // }: {
    //     register: UseFormRegister<FieldValues>
    //     isDone: boolean
    // }) => {
    //     if (!isDone) {
    //         return null
    //     }
    //     return (
    //         <div className="px-8 mt-8" data-testid="test-finishedstatus-section">
    //             <div className="max-w-[552px]">
    //                 <LabelsForInput
    //                     styles={{
    //                         titleStyle: 'text-blueTheme'
    //                     }}
    //                     title="Comentários"
    //                     subtitle="Adicionar comentário na notificação"
    //                 />
    //                 <TextArea
    //                     register={register}
    //                     name="mitigating_factors"
    //                     className={textAreaSmallStyles}
    //                     placeholder="Digite aqui"
    //                     rows={4}
    //                 />
    //                 <ButtonAction
    //                     type="button"
    //                     onClick={() => { }}
    //                     className={actionsBack}
    //                 >
    //                     Enviar comentários
    //                 </ButtonAction>
    //             </div>
    //         </div>
    //     )
    // }